import { render, staticRenderFns } from "./DialogPix.vue?vue&type=template&id=c8923856&scoped=true"
import script from "./DialogPix.vue?vue&type=script&lang=js"
export * from "./DialogPix.vue?vue&type=script&lang=js"
import style0 from "./DialogPix.vue?vue&type=style&index=0&id=c8923856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8923856",
  null
  
)

export default component.exports